import { useState } from 'react';

import { Table, Thead, Tbody, Tr, Th, TableContainer } from '@ecoinvent/ui';

import { FlowDetailProperty } from 'hooks/data/datasets/V4/flows/types';

import PropertyRow from './PropertyRow';

type Props = {
  properties: FlowDetailProperty[];
};

const PropertiesTable = ({ properties }: Props) => {
  const headers: (keyof FlowDetailProperty)[] = ['name', 'amount', 'unit'];
  const [expandedComments, setExpandedComments] = useState<number[]>([]);

  const toggleComment = (index: number) => {
    if (expandedComments.includes(index)) {
      setExpandedComments(expandedComments.filter((i) => i !== index));
    } else {
      setExpandedComments([...expandedComments, index]);
    }
  };

  return (
    <TableContainer>
      <Table variant="simple">
        <Thead>
          <Tr>
            {headers.map((header) => (
              <Th key={header} textAlign="left">
                {header.charAt(0).toUpperCase() + header.slice(1)}
              </Th>
            ))}
            <Th />
          </Tr>
        </Thead>
        <Tbody>
          {properties.map((property, index) => (
            <PropertyRow
              key={index}
              property={property}
              isExpanded={expandedComments.includes(index)}
              onToggleComment={() => toggleComment(index)}
            />
          ))}
        </Tbody>
      </Table>
    </TableContainer>
  );
};

export default PropertiesTable;
